/** localStorage: visitor already finished or dismissed the NPS survey. */
export const NPS_COMPLETED_KEY = "playmath_nps_completed";

/** Fired when a game session starts (timer may begin) or last-game context updates. */
export const NPS_SESSION_CHANGED_EVENT = "playmath:npsSessionChanged";

export const AUDIENCE_SURVEY_CAMPAIGN_KEY = "audience-nps";
export const AUDIENCE_SURVEY_VERSION = "1";
